import React, { FC, useEffect } from 'react'
import Helmet from 'react-helmet'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { RootState } from '../../../../states/containers/store'
import { fetchMailDelivery } from '../../../../states/containers/setting/systemSlice'
import SlackInfo from '../../../components/setting/SlackInfo'

const Index: FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { login } = useSelector<RootState, RootState>((state: RootState) => (state))

  useEffect(() => {
    if (!login.accessToken) return
    dispatch(fetchMailDelivery())
  }, [login.accessToken])

  return (
    <section className="setting_page">
      <Helmet>
        <title>{`Qasee - 設定 - 個人設定 - ${t("setting.slack.caption")}`}</title>
      </Helmet>
      <section className="breadcrumb">
        設定
        &nbsp;&gt;&nbsp;
        個人設定
        &nbsp;&gt;&nbsp;
        {t("setting.slack.caption")}
        &nbsp;
      </section>
      <section className="page_header">
        <h1>
          {t("setting.slack.caption")}
        </h1>
      </section>
      <section className="page_description">
        <p>
          Slackと連携することができます。
        </p>
      </section>
      <section className="page_contents content-area">
        <div className="content-block">
          <div className="block-detail">
            <SlackInfo />
          </div>
        </div>
      </section>
    </section>
  )
}

export default Index
